import { Subtext, Text } from '../../../Components/Screen/Text/Body'
import { Heading } from '../../../Components/Screen/Text/Heading'
import { Plant } from '@phosphor-icons/react'

const certificationColors = {
  Platinum: 'text-purple-300 border-purple-300',
  Gold: 'text-yellow-400 border-yellow-400',
  Silver: 'text-gray-300 border-gray-300',
  Bronze: 'text-orange-400 border-orange-400',
  Wood: 'text-green-400 border-green-400',
  Conditional: 'text-blue-400 border-blue-400',
}

const certificationLabels = {
  Platinum: 'Platina',
  Gold: 'Ouro',
  Silver: 'Prata',
  Bronze: 'Bronze',
  Wood: 'Madeira',
  Conditional: 'Condicional',
}

const FarmCard = ({ art, onClick }) => {
  const cert = art?.deflorestation?.certificationType
  const certColor = certificationColors[cert]
  const certLabel = certificationLabels[cert]
  const cropType = art?.cropDetails?.cropType?.name || art?.cropDetails?.cropType

  return (
    <div
      onClick={onClick}
      className="group flex flex-col rounded-lg border border-cinzaescuro overflow-hidden cursor-pointer hover:border-cinzaclaro transition-colors"
    >
      <div className="relative overflow-hidden">
        <img
          src={art?.withoutqr}
          alt={art?.name}
          className="w-full h-48 object-cover object-center group-hover:scale-105 transition-transform duration-300"
          loading="lazy"
        />
        {certLabel && (
          <span className={`absolute top-2 right-2 text-xs border rounded-full px-2 py-0.5 bg-preto/70 backdrop-blur-sm font-light ${certColor}`}>
            {certLabel}
          </span>
        )}
      </div>

      <div className="flex flex-col gap-2 p-4 bg-cinzaescuro/20">
        <Text className="font-normal truncate">{art?.name}</Text>

        <div className="flex flex-col gap-1">
          {art?.car && (
            <Subtext className="text-cinza truncate">CAR: {art.car}</Subtext>
          )}
          {cropType && (
            <div className="flex items-center gap-1.5">
              <Plant size={14} className="text-verdeClaro shrink-0" />
              <Subtext className="text-verdeClaro truncate">{cropType}</Subtext>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export const FarmsGrid = ({ arts, handleInfos, loading, search }) => {
  if (loading) {
    return (
      <div className="w-full flex flex-col gap-6">
        <Heading>
          Todas as <Heading className="text-laranja">Fazendas</Heading>
        </Heading>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {Array.from({ length: 10 }).map((_, i) => (
            <div key={i} className="rounded-lg border border-cinzaescuro overflow-hidden animate-pulse">
              <div className="w-full h-48 bg-cinzaescuro/40" />
              <div className="p-4 flex flex-col gap-2">
                <div className="h-4 bg-cinzaescuro/60 rounded w-3/4" />
                <div className="h-3 bg-cinzaescuro/40 rounded w-1/2" />
              </div>
            </div>
          ))}
        </div>
      </div>
    )
  }

  const isEmpty = !arts || arts.length === 0

  return (
    <div className="w-full flex flex-col gap-6">
      <div className="flex items-baseline gap-3">
        <Heading>
          Todas as <Heading className="text-laranja">Fazendas</Heading>
        </Heading>
        {!isEmpty && (
          <Text className="text-cinza">
            {arts.length} {arts.length === 1 ? 'fazenda' : 'fazendas'}
            {search ? ' encontradas' : ''}
          </Text>
        )}
      </div>

      {isEmpty ? (
        <div className="flex justify-center items-center w-full h-64 border border-cinzaescuro rounded-lg">
          <Heading className="text-cinza">
            {search ? 'Nenhuma fazenda encontrada para essa busca' : 'Nenhuma fazenda cadastrada'}
          </Heading>
        </div>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4">
          {arts.map((art) => (
            <FarmCard
              key={art?.car || art?.matricula || art?.name}
              art={art}
              onClick={() => handleInfos(art)}
            />
          ))}
        </div>
      )}
    </div>
  )
}
